import { atom } from 'recoil'
import { GameTypes } from 'services'

export const gamesList = atom<GameTypes[]>({
  key: 'gamesList',
  default: []
})
